import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import PageLoader from "../../../../../components/PageLoader";
import { selectGlobaleEventsListItems } from "../../../../../redux/global-events/selector";
import { globalEvents } from "../../../../../redux/global-events/action";
import { eventSubscriptions } from "../../../../../redux/event-subscriptions/action";
import Table from "../../../../../common/components/table-manager/v1.1/table";


const GlobalEvents = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const GlobalEventsItems = useSelector(selectGlobaleEventsListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      {
        field: 'Name', headerName: 'Name', searchField: 'Name', filter: true,
        filterType: 'text'
      },
      { field: 'StartDateUtc', headerName: 'Start Date' },

    ]);
  }

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(globalEvents.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/global-events/list`,
      entity: 'globalEvents', jsonData: {
        
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }))
  }

  const handleReloadData = () => {
    dispatch(globalEvents.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/global-events/list`,
      entity: 'globalEvents',
      jsonData: {
        
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }
  const filterTypes = [{
    name: 'Text', value: "text"
  },
  {
    name: 'Number', value: "number"
  },
  {
    name: 'CheckBox', value: "checkbox"
  },
  {
    name: 'Date', value: "date"
  }
  ]
  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }

  const fetchEvents = () => {
    dispatch(globalEvents.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/global-events/list`,
      entity: 'globalEvents',
      jsonData: {
       
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }


  const additionButtons: any = [

    
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,

      callback: () => handleReloadData(),
    },
  ];

  useEffect(() => {
    createColumnDefs()
    fetchEvents()
  }, [pageData, pageSize])

const handleSubscribe = async (data: any) => {
    await dispatch(eventSubscriptions.resetAction({ actionType: 'create' }));
    await dispatch(eventSubscriptions.create({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/events/subscribe`,
      entity: 'EventSubscriptions',
      jsonData: {
       
        Records: [
          {
            Id: data.Id,
            
          }
        ]
      }
    })).then(() => {
      fetchEvents();
    });
  };
  return (
    <>
      {GlobalEventsItems?.isLoading ? <PageLoader /> :
     <Table
                    checkboxConfig={{
                        allowMultiSelect: true,
                        defaultSelectedIds: [],
                        isDisabled: false,
                        keyColumn: 'Id',
                    }}
                    IsSubscribe={true} handleSubscribe={handleSubscribe}
          filterTypeLists={filterTypes}
          onSearch={handleSearch} columnData={columnDefs}
          rowData={GlobalEventsItems?.result?.items} setPageData={setPageData}
          setPageSize={setPageSize} paginationData={GlobalEventsItems?.result?.pagination}
          onEdit={handleEdit} additionButtons={additionButtons}
       headingName="Global Events"
        />
      }
    </>
  );
};

export default GlobalEvents;